import { toast } from 'react-toastify';
import ToastWithImage from '@monofront/design-system/components/ToastWithImage';
import { INotificationHandlerProps } from '@monofront/business/hooks';

export const notificationToast = ({
  type,
  message,
  product,
}: INotificationHandlerProps) => {
  toast(
    product?.image ? (
      <ToastWithImage message={message} image={product.image} />
    ) : (
      message
    ),
    { type },
  );
};
